<admin-app-header></admin-app-header>
<div class="container-fluid">
    <div class="row">
        <div class="col-3 d-flex align-items-center">
            <h2 class="">3. Payout Batches</h2>
        </div>
        <div class="col-3 d-flex align-items-center">
            <select class="form-select" (change)="onStatusChange($event)">
                <option value="">Filter by Status</option>
                <option *ngFor="let status of PayoutBatchStatusValues" [value]="status">{{ status }}</option>
            </select>
        </div>
        <div class="col-3">
            <!--    <button (click)="globalService.exportcsv('invoices-payouts')" class="btn btn-info btn-sm text-white float-end px-3 py-1 my-2"><i class="fas fa-file-csv"></i> Export to Excel</button>-->
        </div>
    </div>
    <div class="content col-lg-12">
        <table class="table table-striped table-hover table-sm">
            <thead>
                <tr>
                    <th>Created</th>
                    <th>Status</th>
                    <th>Payout Batch ID</th>
                    <th>Payout Date</th>
                    <th>Merchants</th>
                    <th>Invoices</th>
                    <th>Total Amount</th>
                    <th>Payout Amount</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let payoutBatch of filteredPayoutBatches">
                    <tr>
                        <td>{{ payoutBatch.createdAt.toDate() | date: 'dd MMM yyyy' }}</td>
                        <td>
                            <span [ngClass]="EnumNames.getPayoutBatchStatusClass(payoutBatch.status)" class="badge">
                                {{ payoutBatch.status }}
                            </span>
                        </td>
                        <td>
                            <a [routerLink]="['/admin/payout-batch', payoutBatch.$key]" class="text-decoration-underline"> BATCH-{{ payoutBatch.payoutBatchNumber }} </a>
                        </td>
                        <td>
                            <ng-container *ngIf="payoutBatch.payoutDate">
                                {{ payoutBatch.payoutDate.toDate() | date: 'dd MMM yyyy' }}
                            </ng-container>
                        </td>
                        <td>{{ payoutBatch.merchantRefs.length }}</td>
                        <td>{{ payoutBatch.invoiceRefs.length }}</td>
                        <td>{{ payoutBatch.totalAmount | currency: 'R' }}</td>
                        <td>{{ payoutBatch.payoutAmount | currency: 'R' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
